import VerifyIngredients from './VerifyIngredients';
export default VerifyIngredients;
